module.exports = __webpack_public_path__ + "static/media/500Mbps.81b0d766.bin";